import axios from "axios";
import DOMPurify from 'dompurify';
import React, { useEffect, useState, Fragment } from "react";
import {NavLink, useNavigate} from "react-router-dom";
import clientconfigwebapp, {
    convert_to_english_strhk,
    scrollTo_uphk,
    modal_login_reg_bk_show,
    modal_login_reg_all_hide,
    empty_bk,
    redirectbh_typeb
} from '../../clientconfigwebapp';
import { ToastContainer, toast } from 'react-toastify';
import "../../assets/css/sign.css"
import "../../assets/css/signDes.css"
import ReactFullPageLoadinghk from "../../components/layaout/LoadingFullpagehk";
import logo_main from "../../assets/images/logo.png";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
const serialize = require('form-serialize');

const Modal_Login_reg = (props) => {
    const navigate = useNavigate();
    const [loadinghkfullshow, Setloadinghkfullshow] = useState(false);
    const [phone_mobile, setphone_mobile] = useState('');
    const [phone_mobile_forgot, setphone_mobile_forgot] = useState('');
    const [first_name, setFirst_name] = useState('');
    const [last_name, setLast_name] = useState('');
    const [password, setPassword] = useState('');
    const [show_hide_view_Verification_code, set_show_hide_view_Verification_code] = useState('');
    const [Position_view, setPosition_view] = useState("sign");
    const [phone_mobile_login, set_phone_mobile_login] = useState('');
    const [password_login, set_password_login] = useState('');
    const [page_view_reg_verification_page, set_page_view_reg_verification_page] = useState('reg_verification_page');
    const [reg_verification_code, setRegVerification_code] = useState('');
    const [phone_mobile_login_reg_check, set_phone_mobile_login_reg_check] = useState('');
    const [value, setValue] = useState('simple');

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        let myInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(myInterval)
                } else {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
            }
        }, 1000);
        return () => {
            clearInterval(myInterval);
        };
    });

    useEffect(() => {
        scrollTo_uphk();
        setMinutes(2);
    }, []);

    const Handler_login_show_bk = () => {
        modal_login_reg_bk_show("loginshow");
    };

    const Handle_forgotpassword_show_bk = () => {
        modal_login_reg_bk_show("forgotpassword");
    };

    const Handle_register_show_bk = () => {
        modal_login_reg_bk_show("regloginshow");
    };

    const Handle_login_register_closeall = () => {
        modal_login_reg_all_hide();
    };

    const first_name_Handler = (event) => {
        setFirst_name(convert_to_english_strhk(event.target.value));
    }

    const last_name_Handler = (event) => {
        setLast_name(convert_to_english_strhk(event.target.value));
    }

    const phone_mobile_Handler = (event) => {
        setphone_mobile(convert_to_english_strhk(event.target.value));
    }

    const password_Handler = (event) => {
        setPassword(convert_to_english_strhk(event.target.value));
    }

    const password_login_Handler = (event) => {
        set_password_login(convert_to_english_strhk(event.target.value));
    }

    const phone_mobile_HandlerFocus = (event) => {
        window.scrollTo(0, 0);
    }

    const phone_mobile_Handler_forgot = (event) => {
        setphone_mobile_forgot(convert_to_english_strhk(event.target.value));
    }

    const validate_form_Forgot = () => {
        if (phone_mobile_forgot === '') {
            toast.error('شماره موبایل وارد نشده', { position: "top-center", autoClose: 5000 });
            return false;
        }
        return true;
    }

    const Handler_phone_login_reg_check = (event) => {
        set_phone_mobile_login_reg_check(convert_to_english_strhk(event.target.value));
    }

    const HandlerLogin_reg_check_req = () => {
        if (phone_mobile_login_reg_check === '') {
            toast.error('شماره موبایل وارد نشده', { position: "top-center", autoClose: 5000 });
            return false;
        }

        let form_data = document.querySelector('#form_Registerpagewebapp');
        if (form_data != null) {
            let data_serialize = serialize(form_data);
            Setloadinghkfullshow(true);

            axios.post(`${clientconfigwebapp.siteurl}api/v1/req-login-reg-check-pr`, data_serialize)
                .then((res) => {
                    Setloadinghkfullshow(false);
                    if (!empty_bk(res.data.data)) {
                        if (String(res.data.data) == "login_verification_page") {
                            login_verification_page_show("login_verification_page");
                            modal_login_reg_bk_show("verification_code_reg_show");
                        }
                        if (String(res.data.data) == "reg_verification_page") {
                            login_verification_page_show("reg_verification_page");
                            modal_login_reg_bk_show("verification_code_reg_show");
                        }
                    } else {
                        toast.error(res.data.msgwebapp, { position: "top-center", autoClose: 5000 });
                    }
                }).catch((err) => {
                Setloadinghkfullshow(false);
                toast.error('خطای اتصال به سرور کد 5431', { position: "top-center", autoClose: 5000 });
                console.error(err, "is error 5431!");
            });
        } else {
            alert('errcode:14');
        }
    }

    const Handler_Register_login_Verification = () => {
        if (phone_mobile_login_reg_check === '') {
            toast.error('شماره موبایل وارد نشده', { position: "top-center", autoClose: 5000 });
            return false;
        }
        if (reg_verification_code === '') {
            toast.error('کد تایید وارد نشده', { position: "top-center", autoClose: 5000 });
            return false;
        }

        let form_data = document.querySelector('#form_Registerpagewebapp');
        if (form_data != null) {
            let data_serialize = serialize(form_data);
            Setloadinghkfullshow(true);
            axios.post(`${clientconfigwebapp.siteurl}api/v1/reg-register-verification/`, data_serialize)
                .then((res) => {
                    Setloadinghkfullshow(false);
                    if (!empty_bk(res.data.data)) {
                        if (String(res.data.data) == "reg_complate_form_page") {
                            modal_login_reg_bk_show("regloginshow");
                        }
                    } else {
                        toast.error(res.data.msgwebapp, { position: "top-center", autoClose: 5000 });
                    }
                }).catch((err) => {
                Setloadinghkfullshow(false);
                toast.error('خطای اتصال به سرور کد 5431', { position: "top-center", autoClose: 5000 });
                console.error(err, "is error 5431!");
            });
        } else {
            alert('errcode:657567567567');
        }
    }

    const verification_code_reg_Handler = (event) => {
        setRegVerification_code(convert_to_english_strhk(event.target.value));
        if (String(convert_to_english_strhk(event.target.value)).length == 5) {
            if (page_view_reg_verification_page == "login_verification_page") {
                Handler_req_login_code_sms_Verification();
            } else if (page_view_reg_verification_page == "reg_verification_page") {
                Handler_Register_login_Verification();
            }
        }
    }

    const Handler_Register_complate = () => {
        if (first_name === '') {
            toast.error('نام درست وارد نشده', { position: "top-center", autoClose: 5000 });
            return false;
        } else if (last_name === '') {
            toast.error('نام خانوادگی درست وارد نشده', { position: "top-center", autoClose: 5000 });
            return false;
        } else if (phone_mobile_login_reg_check === '') {
            toast.error('شماره موبایل وارد نشده', { position: "top-center", autoClose: 5000 });
            return false;
        }

        var redirect_id_loginreg = document.getElementById("redirect_id_loginreg");

        let form_data = document.querySelector('#form_Registerpagewebapp');
        if (form_data != null) {
            let data_serialize = serialize(form_data);
            Setloadinghkfullshow(true);
            axios.post(`${clientconfigwebapp.siteurl}api/v1/req-register-complate-pr/`, data_serialize)
                .then((res) => {
                    Setloadinghkfullshow(false);
                    if (!empty_bk(res.data.data)) {
                        localStorage.setItem('tokenacess', res.data.data);
                        if (!empty_bk(res.data.first_name)) {
                            localStorage.setItem('first_name_Get', res.data.first_name);
                        }
                        if (!empty_bk(res.data.last_name)) {
                            localStorage.setItem('last_name_Get', res.data.last_name);
                        }
                        modal_login_reg_all_hide();
                        if (redirect_id_loginreg != null) {
                            const sanitizedRedirectURL = DOMPurify.sanitize(document.getElementById("redirect_id_loginreg").value);
                            if (!empty_bk(sanitizedRedirectURL)) {
                                redirectbh_typeb(String(clientconfigwebapp.webappurl) + sanitizedRedirectURL);
                            } else {
                                window.location.reload();
                            }
                        } else {
                            window.location.reload();
                        }
                    } else {
                        toast.error(res.data.msgwebapp, { position: "top-center", autoClose: 5000 });
                    }
                }).catch((err) => {
                Setloadinghkfullshow(false);
                toast.error('خطای اتصال به سرور کد 456456', { position: "top-center", autoClose: 5000 });
                console.error(err, "is error 5431!");
            });
        } else {
            alert('errcode:14');
        }
    }

    const login_verification_page_show = (valueget) => {
        setRegVerification_code("");
        if (String(valueget) == "reg_verification_page") {
            set_page_view_reg_verification_page("reg_verification_page");
        }
        if (String(valueget) == "login_verification_page") {
            set_page_view_reg_verification_page("login_verification_page");
        }
    }

    const Handler_req_login_code_sms_Verification = () => {
        if (phone_mobile_login_reg_check === '') {
            toast.error('شماره موبایل وارد نشده', { position: "top-center", autoClose: 5000 });
            return false;
        }
        if (reg_verification_code === '') {
            toast.error('کد تایید وارد نشده', { position: "top-center", autoClose: 5000 });
            return false;
        }

        var redirect_id_loginreg = document.getElementById("redirect_id_loginreg");

        let form_data = document.querySelector('#form_Registerpagewebapp');
        if (form_data != null) {
            let data_serialize = serialize(form_data);
            Setloadinghkfullshow(true);
            axios.post(`${clientconfigwebapp.siteurl}api/v1/req_login_code_verification-pr/`, data_serialize)
                .then((res) => {
                    Setloadinghkfullshow(false);
                    if (!empty_bk(res.data.data)) {
                        localStorage.setItem('tokenacess', res.data.data);
                        if (!empty_bk(res.data.first_name)) {
                            localStorage.setItem('first_name_Get', res.data.first_name);
                        }
                        if (!empty_bk(res.data.last_name)) {
                            localStorage.setItem('last_name_Get', res.data.last_name);
                        }
                        modal_login_reg_all_hide();
                        if (redirect_id_loginreg != null) {
                            const sanitizedRedirectURL = DOMPurify.sanitize(document.getElementById("redirect_id_loginreg").value);
                            if (!empty_bk(sanitizedRedirectURL)) {
                                redirectbh_typeb(String(clientconfigwebapp.webappurl) + sanitizedRedirectURL);
                            } else {
                                window.location.reload();
                            }
                        } else {
                            window.location.reload();
                        }
                    } else {
                        toast.error(res.data.msgwebapp, { position: "top-center", autoClose: 5000 });
                    }
                }).catch((err) => {
                Setloadinghkfullshow(false);
                toast.error('خطای اتصال به سرور کد 5431', { position: "top-center", autoClose: 5000 });
                console.error(err, "is error 5431!");
            });
        } else {
            alert('errcode:657567567567');
        }
    }

    return (
        <Fragment>
            <div className="fullbox_reg_login_main">
                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow} />
                <ToastContainer />
                <section className="flexColStartCenter sign-container">
                    <form id="form_Registerpagewebapp">
                        <input
                            id="redirect_id_loginreg"
                            name="redirect_id_loginreg"
                            value={DOMPurify.sanitize(props.redirectURL || 'panel/dashboard')}
                            style={{ display: "none" }}
                        />
                        <input
                            id="user_type"
                            name="user_type"
                            value={'simple'}
                            style={{ display: "none" }}
                        />
                        <section style={(() => {
                            if (show_hide_view_Verification_code === "show") {
                                return ({ display: "none" });
                            } else {
                                return ({ display: "block" });
                            }
                        })()}>
                            <NavLink  reloadDocument={true} to={"/"} className={"logo_reg_login_modal"} style={{ textAlign: "center" }}><img src={logo_main} alt="Logo" /></NavLink>
                            <div id="login_reg_check_view_modal" className="flexColStartStart" style={{ display: "block" }}>
                                <span style={{
                                    display: "block",
                                    textAlign: "right",
                                    paddingTop: "8px",
                                    paddingBottom: "20px",
                                    color: "black",
                                    fontWeight: "bold",
                                    fontSize: "14px"
                                }}>به بازارانو خوش آمدید !</span>
                                <span>ورود / ثبت نام</span>
                                <div className="box-input-formreg-login">
                                    <label>شماره همراه</label>
                                    <input placeholder={"شماره همراه خود را وارد کنید"} type="text" name="phone_mobile" onChange={Handler_phone_login_reg_check}
                                           style={{ direction: "rtl" }} />
                                </div>
                                <button type="button" onClick={HandlerLogin_reg_check_req}
                                        style={{ width: "100%", marginBottom: "16px" }}
                                        className="btn-bh btn-black-bh">
                                    دریافت کد تایید
                                </button>
                            </div>
                            <div id="verification_code_reg_view_modal" className="flexColStartStart" style={{ display: "block" }}>
                                <span style={{
                                    display: "block",
                                    textAlign: "right",
                                    paddingTop: "8px",
                                    paddingBottom: "20px",
                                    color: "black",
                                    fontWeight: "bold"
                                }}>کد تایید را وارد کنید.</span>
                                <div style={{ fontSize: "13px", textAlign: "right", color: "#a29c9c" }}>کد 5 رقمی ارسال شده به <span id={"phone_number_Reglog"}> {phone_mobile_login_reg_check} </span> را وارد کنید.</div>
                                <div className="box-input-formreg-login">
                                    <label></label>
                                    <input style={{ textAlign: "center" }} onChange={verification_code_reg_Handler} type="text" name="verification_code" />
                                </div>
                                <div style={{ textAlign: "center", paddingTop: "10px", paddingBottom: "16px" }}>
                                    {minutes === 0 && seconds === 0
                                        ? <button type="button" style={{ border: "none", backgroundColor: "white" }}><span
                                            style={{
                                                fontSize: "12px",
                                                color: "#01A3D4",
                                                fontFamily: "iran",
                                                paddingLeft: "10px"
                                            }}>رمز را دریافت نکردید ؟</span><span style={{
                                            fontSize: "15px",
                                            color: "#ff5e14",
                                            fontFamily: "iran",
                                            paddingLeft: "10px"
                                        }}>ارسال مجدد</span></button>
                                        : <div>
                                            <span style={{
                                                fontSize: "15px",
                                                color: "#ff5e14",
                                                fontFamily: "iran",
                                                paddingLeft: "10px"
                                            }}>{minutes}:{seconds < 10 ? `0${seconds}` : seconds}</span>
                                            <span style={{
                                                fontSize: "12px",
                                                color: "#01A3D4",
                                                fontFamily: "iran",
                                                paddingLeft: "10px"
                                            }}>مانده تا دریافت مجدد کد </span>
                                        </div>
                                    }
                                </div>
                                {page_view_reg_verification_page === "login_verification_page" ? (
                                    <Fragment>
                                        <button type="button" onClick={Handler_req_login_code_sms_Verification}
                                                style={{ width: "100%", marginBottom: "16px" }}
                                                className="btn-bh btn-black-bh">تایید کد
                                        </button>
                                    </Fragment>) : (
                                    <Fragment>
                                        <button type="button" onClick={Handler_Register_login_Verification}
                                                style={{ width: "100%", marginBottom: "16px" }}
                                                className="btn-bh btn-black-bh">ادامه
                                        </button>
                                    </Fragment>)}
                            </div>
                            <div id="register_view_modal" className="flexColStartStart" style={{ display: "none" }}>
                                <div style={{ fontSize: "13px", textAlign: "right", color: "black", fontWeight: "bold", marginBottom: "10px" }}>
                                    نوع فعالیت
                                </div>
                                <FormControl>
                                    <RadioGroup
                                        aria-labelledby="type_activity"
                                        name="type_activity"
                                        value={value}
                                        onChange={handleChange}
                                        color="secondary"
                                        className={"type_activity_btn"}
                                    >
                                        <FormControlLabel value="simple" control={<Radio />} label="خریدار" />
                                        <FormControlLabel value="seller" control={<Radio />} label="فروشنده" />
                                    </RadioGroup>
                                </FormControl>
                                <Grid container direction="row" spacing={2} style={{ paddingTop: "14px" }}>
                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <div className="box-input-formreg-login">
                                            <label>نام</label>
                                            <input onChange={first_name_Handler} type="text" name="first_name" />
                                        </div>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <div className="box-input-formreg-login">
                                            <label>نام خانوادگی</label>
                                            <input onChange={last_name_Handler} type="text" name="last_name" />
                                        </div>
                                    </Grid>
                                </Grid>
                                <div>
                                    <span style={{ display: "block", textAlign: "center", fontSize: "12px", marginBottom: "17px" }}>ثبت نام شما به معنای پذیرش قوانین و مقررات بازارنو است.</span>
                                    <button type="button" onClick={Handler_Register_complate}
                                            style={{ width: "100%", marginBottom: "16px" }}
                                            className="btn-bh btn-black-bh">
                                        تکمیل ثبت نام
                                    </button>
                                </div>
                            </div>
                            <div id="login_view_modal" className="flexColStartStart" style={{ display: "none" }}>
                            </div>
                            <div id="forgot_view_modal" className="flexColStartStart" style={{ display: "none" }}>
                            </div>
                            <div id="forgot_message_view_modal" className="flexColStartStart" style={{ display: "none" }}>
                            </div>
                        </section>
                    </form>
                </section>
            </div>
        </Fragment>
    );
}

export default Modal_Login_reg;
